import i18nFactory from '@yandex-int/i18n';
import { get } from 'lodash';

import { ValidationResultItem } from '../../../typings/common';
import { createErrorsMapper } from '../../ErrorsMapper/ErrorsMapper';

import * as keyset from './SitelinksErrorsTextMapper.i18n';

const i18n = i18nFactory(keyset);

export const sitelinksErrorsTextMapper = createErrorsMapper<{}>(
    ({ idx }) => [
        {
            path: ['sitelinks'],
            codes: [
                {
                    code:
                        'SitelinkDefectIds.Strings.MAX_SITELINKS_FIRST_BLOCK_TITLES_LENGTH',
                    message: (err: ValidationResultItem): string => {
                        return i18n(
                            'sitelinks-first-block-common-title-max-length',
                            {
                                maxLength: get(err, 'params.maxLength', '')
                            }
                        );
                    }
                },
                {
                    code:
                        'SitelinkDefectIds.Strings.MAX_SITELINKS_TITLES_LENGTH',
                    message: (err: ValidationResultItem): string => {
                        return i18n('sitelinks-common-title-max-length', {
                            maxLength: get(err, 'params.maxLength', '')
                        });
                    }
                },
                {
                    code:
                        'SitelinkDefectIds.Strings.MAX_SITELINKS_SECOND_BLOCK_TITLES_LENGTH',
                    message: (err: ValidationResultItem): string => {
                        return i18n(
                            'sitelinks-second-block-common-title-max-length',
                            {
                                maxLength: get(err, 'params.maxLength', '')
                            }
                        );
                    }
                },
                {
                    code: 'SitelinkDefectIds.Gen.DUPLICATE_SITELINK_TITLES',
                    message: (err: ValidationResultItem): string => {
                        return i18n('sitelinks-duplicate-errors');
                    }
                },
                {
                    code: 'NEED_TO_SAVE',
                    message: (err: ValidationResultItem): string => {
                        return i18n('sitelinks-need-to-save');
                    }
                },
                {
                    code: 'SitelinkDefectIds.Gen.DUPLICATE_SITELINK_DESCS',
                    message: (err: ValidationResultItem): string => {
                        return i18n('sitelink-descr-dublicate');
                    }
                }
            ]
        },
        {
            path: ['sitelinks', idx, 'title'],
            codes: [
                {
                    code:
                        'SitelinkDefectIds.Strings.SITELINK_TITLE_LENGTH_CANNOT_BE_MORE_THAN_MAX',
                    message: (err: ValidationResultItem): string => {
                        return i18n('sitelink-title-max-length', {
                            maxLength: get(err, 'params.maxLength', '')
                        });
                    }
                },
                {
                    code:
                        'SitelinkDefectIds.Gen.SITELINK_TITLE_CANNOT_BE_EMPTY',
                    message: (err: ValidationResultItem): string => {
                        return i18n('sitelink-title-empty');
                    }
                },
                {
                    code:
                        'SitelinkDefectIds.Strings.ALLOWED_SYMBOLS_SITELINK_TITLE',
                    message: (err: ValidationResultItem): string => {
                        return i18n('sitelink-title-restricted-chars-in-field');
                    }
                }
            ]
        },
        {
            path: ['sitelinks', idx, 'link'],
            codes: [
                {
                    code: 'SitelinkDefectIds.Gen.INVALID_SITELINK_HREF',
                    message: (err: ValidationResultItem): string => {
                        return i18n('sitelink-href-invalid');
                    }
                },
                {
                    code:
                        'SitelinkDefectIds.Strings.SITELINK_HREF_LENGTH_CANNOT_BE_MORE_THAN_MAX',
                    message: (err: ValidationResultItem): string => {
                        return i18n('sitelink-href-length', {
                            maxLength: get(err, 'params.maxLength', '')
                        });
                    }
                },
                {
                    code: 'sitelink_domain_not_match_mainlink_domain',
                    message: (err: ValidationResultItem): string => {
                        return i18n('link-domain-not-match-main');
                    }
                }
            ]
        },
        {
            path: ['sitelinks', idx, 'descr'],
            codes: [
                {
                    code:
                        'SitelinkDefectIds.Strings.SITELINK_DESCRIPTION_LENGTH_CANNOT_BE_MORE_THAN_MAX',
                    message: (err: ValidationResultItem): string => {
                        return i18n('sitelink-descr-max-length', {
                            maxLength: get(err, 'params.maxLength', '')
                        });
                    }
                },
                {
                    code:
                        'SitelinkDefectIds.Gen.SITELINK_DESCRIPTION_CANNOT_BE_EMPTY',
                    message: (err: ValidationResultItem): string => {
                        return i18n('sitelink-descr-no-empty');
                    }
                },
                {
                    code:
                        'SitelinkDefectIds.Strings.ALLOWED_SYMBOLS_SITELINK_DESC',
                    message: (err: ValidationResultItem): string => {
                        return i18n('sitelink-descr-allowed-symbols');
                    }
                },
                {
                    code:
                        'SitelinkDefectIds.Strings.ALLOWED_SYMBOLS_SITELINK_DESC',
                    message: (err: ValidationResultItem): string => {
                        return i18n('sitelink-descr-not-allowed-symbols');
                    }
                }
            ]
        }
    ],
    error =>
        i18n('sitelinks-unknown-error', { path: error.path, code: error.code })
);
